import { Loader2 } from 'lucide-react';

export function LoadingScreen() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-merino-50 to-white">
      <div className="text-center">
        <Loader2 className="mx-auto h-12 w-12 animate-spin text-merino-500" />
        <p className="mt-4 text-gray-600">Cargando...</p>
      </div>
    </div>
  );
}

